<div [formGroup]="group" class="field">
    <div class="legal-consent-container" *ngIf="consentData.isLegitimateInterest">
        <!-- show privacy text only. everything else is set implicitly-->
        <ng-container *ngTemplateOutlet="privacyPolicy"></ng-container>
    </div>

    <div class="legal-consent-container" *ngIf="!consentData.isLegitimateInterest && consentData.processingConsentType === 'IMPLICIT'">
        <!-- consent checkbox for communication, form sumit is consent to process data-->
        <ng-container *ngTemplateOutlet="explicitCommunicationConsent"></ng-container>
        <ng-container *ngTemplateOutlet="privacyPolicy"></ng-container>
        <ng-container *ngTemplateOutlet="implicitProcessingConsent"></ng-container>
    </div>

    <!-- consent checkbox for communication, consent checkbox for  process data-->
    <div
        class="legal-consent-container"
        *ngIf="!consentData.isLegitimateInterest && consentData.processingConsentType === 'REQUIRED_CHECKBOX'"
    >
        <ng-container *ngTemplateOutlet="explicitCommunicationConsent"></ng-container>
        <ng-container *ngTemplateOutlet="processingConsent"></ng-container>
        <ng-container *ngTemplateOutlet="privacyPolicy"></ng-container>
    </div>

    <ng-template #explicitCommunicationConsent>
        <ng-container *ngIf="consentData.communicationConsentText">
            <span class="consentdata" [innerHtml]="consentData.communicationConsentText"></span>
        </ng-container>
        <ng-container *ngFor="let checkbox of consentData.communicationConsentCheckboxes">
            <label [for]="'LEGAL_CONSENT.subscription_type_' + checkbox.communicationTypeId + '-' + formId" class="checkboxlabel">
                <input
                    type="checkbox"
                    [id]="'LEGAL_CONSENT.subscription_type_' + checkbox.communicationTypeId + '-' + formId"
                    [formControlName]="'LEGAL_CONSENT.subscription_type_' + checkbox.communicationTypeId"
                    [required]="checkbox.required"
                    (change)="onCheckboxChange($event.target.checked, 'LEGAL_CONSENT.subscription_type_' + checkbox.communicationTypeId)"
                />
                <span class="consentdata" [ngClass]="{ required: checkbox.required }" [innerHTML]="checkbox.label"></span>
            </label>
            <ng-container
                *ngIf="(isSubmitting$ | async) && group.controls['LEGAL_CONSENT.subscription_type_' + checkbox.communicationTypeId].touched"
            >
                <ng-container
                    *ngFor="
                        let error of group.controls['LEGAL_CONSENT.subscription_type_' + checkbox.communicationTypeId].errors
                            | getIterableErrors
                    "
                >
                    <span class="error-msg">{{ getErrorTranslation(error) }}</span>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-template>

    <ng-template #implicitProcessingConsent>
        <ng-container *ngIf="consentData.processingConsentText">
            <div class="consentdata" [innerHtml]="consentData.processingConsentText"></div>
        </ng-container>
    </ng-template>

    <ng-template #privacyPolicy>
        <ng-container *ngIf="consentData.privacyPolicyText"><span [innerHtml]="consentData.privacyPolicyText"></span> </ng-container>
    </ng-template>
    <ng-template #processingConsent>
        <ng-container *ngIf="consentData.processingConsentText"><span [innerHtml]="consentData.processingConsentText"></span></ng-container>
        <label for="LEGAL_CONSENT.processing-{{ formId }}" class="checkboxlabel">
            <input
                type="checkbox"
                id="LEGAL_CONSENT.processing-{{ formId }}"
                [formControlName]="'LEGAL_CONSENT.processing'"
                (change)="onCheckboxChange($event.target.checked, 'LEGAL_CONSENT.processing')"
            />
            <ng-container *ngIf="consentData.processingConsentCheckboxLabel">
                <div class="consentdata required" [innerHtml]="consentData.processingConsentCheckboxLabel"></div>
            </ng-container>
        </label>
        <ng-container *ngIf="(isSubmitting$ | async) && group.controls['LEGAL_CONSENT.processing'].touched">
            <ng-container *ngFor="let error of group.controls['LEGAL_CONSENT.processing'].errors | getIterableErrors">
                <span class="error-msg">{{ getErrorTranslation(error) }}</span>
            </ng-container>
        </ng-container>
    </ng-template>
</div>
